/* ===========================================================================
   ne-main-drawer.js — the "All" slide-out menu.

   The burger lives inside the header section, which the Theme Editor can
   re-render, so the trigger is bound by delegation rather than to the node.
   =========================================================================== */
(function () {
  'use strict';

  var drawer = document.getElementById('ne-main-drawer');
  if (!drawer) return;

  var panel = document.getElementById('ne-md-panel');
  var lastFocus = null;

  function burger(){ return document.getElementById('ne-burger'); }
  // every other opener (the mobile home's bottom-nav Menu) mirrors the state
  function triggers(on){
    document.querySelectorAll('[data-ne-open-menu]').forEach(function(t){
      t.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  function lock(on){
    document.documentElement.classList.toggle('ne-md-locked', on);
    document.body.classList.toggle('ne-md-locked', on);
  }

  function open(){
    lastFocus = document.activeElement;
    drawer.hidden = false;
    lock(true);
    void drawer.offsetWidth;          // reflow so the slide-in transition runs
    drawer.classList.add('is-open');
    var b = burger();
    if (b) b.setAttribute('aria-expanded', 'true');
    triggers(true);
    panel.scrollTop = 0;
    panel.focus();
    document.addEventListener('keydown', onKeydown, true);
  }

  function close(){
    drawer.classList.remove('is-open');
    lock(false);
    var b = burger();
    if (b) b.setAttribute('aria-expanded', 'false');
    triggers(false);
    document.removeEventListener('keydown', onKeydown, true);
    // wait out the slide-out before pulling it from the a11y tree
    setTimeout(function(){ if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 240);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKeydown(e){
    if (e.key === 'Escape'){ e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = [].slice.call(drawer.querySelectorAll('a[href], button:not([disabled])'))
             .filter(function(el){ return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  }

  document.addEventListener('click', function(e){
    var t = e.target;
    if (t.closest && t.closest('#ne-burger, [data-ne-open-menu]')){ e.preventDefault(); open(); return; }
    if (t.closest && t.closest('[data-ne-md-close]')){ e.preventDefault(); close(); }
  });
})();
